/* Copyright 2011-2012 The MathWorks, Inc. */

/**
 * This returns an object with some commonly used helper functions as properties.
 */

define([
    "dijit/registry",
    "dojo/_base/kernel",
    "dojo/_base/window",
    "dojo/dom-geometry",
    "dojo/dom-construct",
    "./constants/TypeConstants",
    "./hashes/ComponentsThatDontSupportAction",
    "./hashes/PeerNodeTypesWithNoCorrespondingWidget"
], function (registry, kernel, win, domGeom, domConstruct, TypeConstants, ComponentsThatDontSupportAction, PeerNodeTypesWithNoCorrespondingWidget) {
    return {
        isGalleryPopupAttachedWithGallery: function (node) {
            return node.domNode.classList.contains("gallery");
        },
        
        isAPopupList: function (type) {
            return type === TypeConstants.POPUP_LIST;
        },

        isAListItemWithPopup: function (type) {
            return type === TypeConstants.LIST_ITEM_WITH_POPUP;
        },

        isAMenubarWrapper: function (type) {
            return type === TypeConstants.MENUBAR_WRAPPER;
        },

        isAToolbarWrapper: function (type) {
            return type === TypeConstants.TOOLBAR_WRAPPER;
        },

        isAColumn: function (type) {
            return type === TypeConstants.COLUMN;
        },

        isAPanel: function (type) {
            return type === TypeConstants.PANEL;
        },

        supportsAction: function (type) {
            return (ComponentsThatDontSupportAction.indexOf(type) === -1);
        },

        isAFooterCell: function (type) {
            return type === TypeConstants.FOOTER_CELL;
        },

        hasNoCorrespondingWidget: function (type) {
            return PeerNodeTypesWithNoCorrespondingWidget.indexOf(type) > -1;
        },

        findParent: function (widget, parentType) {
            var parent = null, parentPopupId;

            while (widget) {
                parentPopupId = null;

                if (widget.get("type") === parentType) {
                    parent = widget;
                    break;
                }

                if (widget.domNode.parentNode) {
                    parentPopupId = widget.domNode.parentNode.getAttribute("dijitpopupparent");
                }

                // If the widget is in one of the popups, then go up the popup parent chain
                if (parentPopupId) {
                    widget = registry.byId(parentPopupId);
                    // If its not one of the popups, then go to parent
                } else {
                    widget = widget.getParent();
                }
            }

            return parent;
        },

        findParentToolstrip: function (widget) {
            return this.findParent(widget, TypeConstants.TOOLSTRIP);
        },

        findParentSection: function (widget) {
            return this.findParent(widget, TypeConstants.SECTION);
        },

        getClosestValue: function (a, x) {
            var lo = -1, hi = a.length, mid;
            while (hi - lo > 1) {
                mid = Math.round((lo + hi) / 2);
                if (a[mid] <= x) {
                    lo = mid;
                } else {
                    hi = mid;
                }
            }
            if (a[lo] === x) {
                hi = lo;
            }
            return [a[lo], a[hi]];
        },

        computeWidth: function(value, height, style) {
            return parseInt(this._computeStyle(value, null, height, style).width);
        },

        computeHeight: function(value, width, style) {
            return parseInt(this._computeStyle(value, width, null, style).height);
        },

        _computeStyle: function(value, width, height, style) {
            var dummyNode, computedStyle;

            if (width == null) {
                width = "auto";
            }

            if (height == null) {
                height = "auto";
            }

            if (style == null) {
                style = "";
            }

            dummyNode = document.createElement("div");
            dummyNode.classList.add("dijitOffScreen");

            // Add toolstrip class to be able to get the correct font-size and font-family
            dummyNode.classList.add("toolstrip");

            dummyNode.style = style;

            document.body.appendChild(dummyNode);
            dummyNode.textContent = value;
            computedStyle = window.getComputedStyle(dummyNode, null);
            var result = {width: computedStyle.width, height: computedStyle.height};
            document.body.removeChild(dummyNode);
            return result;
        }

    };
});